import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
					<div className="projects-container">
						<div className="title projects-title">
							My Journey as Recruitment Consultant
						</div>

						<div className="subtitle projects-subtitle">
							Throughout my career as a Recruitment Consultant, I’ve successfully led strategic hiring efforts across travel (W2), permanent, and locum tenens roles. I’m proud to have worked with leading platforms and VMS tools, optimizing candidate sourcing and streamlining recruitment operations. I believe in creating meaningful connections that drive long-term results for clients and candidates alike. If you're looking to collaborate on innovative hiring strategies or explore recruitment solutions, I’d be happy to connect and discuss opportunities.
						</div>
					</div>


						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
